import * as Yup from "yup";
const TRANSLATION_BASE_PATH = "_LOGIN._REGISTER";

export const formValidatorParentEmail = (translate: (key: string) => string) =>
	Yup.object({
		email: Yup.string()
			.email(translate(`${TRANSLATION_BASE_PATH}._NOT_VALID_EMAIL`))
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
	});
